import { createSlice } from "@reduxjs/toolkit";

const encounterSlice = createSlice({
    name: "encounters",
    initialState: {},
    reducers: {
        registerEncounter: (state, action) => {
            const encounter = action.payload;

            if (!encounter?.id) return;

            // Only add if not already present
            if (!state[encounter.id]) {
                state[encounter.id] = encounter;
            } else {
                console.warn(
                    `⚠️ Encounter ${encounter.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterEncounters: (state, action) => {
            action.payload.forEach((encounter) => {
                if (!encounter?.id) return;

                if (!state[encounter.id]) {
                    state[encounter.id] = encounter;
                } else {
                    console.warn(
                        `⚠️ Encounter ${encounter.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerEncounter,
    bulkRegisterEncounters
} = encounterSlice.actions;

export default encounterSlice.reducer;
